import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { GlassHouseBrandGroupThreeByFourStackBackgroundViewModel } from './glass-house-brand-group-three-by-four-stack-background-view-model';
import type { GlassHouseBrandGroupCardData } from '../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';

@Component({
  selector: 'app-glass-house-brand-group-three-by-four-stack-background',
  templateUrl: './glass-house-brand-group-three-by-four-stack-background.component.html',
  styleUrl: './glass-house-brand-group-three-by-four-stack-background.component.scss',
  providers: [GlassHouseBrandGroupThreeByFourStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseBrandGroupThreeByFourStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: GlassHouseBrandGroupThreeByFourStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GlassHouseBrandGroupCardData;
}
